<template>
  <div class="q-page">
    <div class="container py-5">
      <p class="q-section-title mb-2">Armá tu PC</p>
      <p class="q-pcbuilder-sub mb-5">Elegí tu plataforma y comenzá a seleccionar los componentes</p>

      <div class="q-brand-grid">
        <router-link :to="{ name: 'PC Builder Intel' }" class="q-brand-card">
          <div class="q-brand-card__img q-brand-card__img--intel"></div>
          <span class="q-brand-card__label">Intel</span>
        </router-link>
        <router-link :to="{ name: 'PC Builder AMD' }" class="q-brand-card">
          <div class="q-brand-card__img q-brand-card__img--amd"></div>
          <span class="q-brand-card__label">AMD</span>
        </router-link>
      </div>

      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.q-pcbuilder-sub {
  font-size: 13px;
  color: var(--q-text-muted);
}

.q-brand-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 640px;
}
@media (max-width: 480px) { .q-brand-grid { grid-template-columns: 1fr; } }

.q-brand-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: var(--q-bg-surface);
  border: 1px solid var(--q-border);
  border-radius: var(--q-radius-lg);
  padding: 32px;
  text-decoration: none;
  transition: border-color var(--q-transition), background var(--q-transition);
}
.q-brand-card:hover {
  border-color: var(--primary-color);
  background: rgba(0, 112, 243, 0.05);
}

.q-brand-card__img {
  width: 200px; height: 100px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.q-brand-card__img--intel { background-image: url('/img/intel.jpg'); }
.q-brand-card__img--amd   { background-image: url('/img/AMD.jpg'); }

.q-brand-card__label {
  font-family: var(--q-font-display);
  font-size: 13px; font-weight: 700;
  letter-spacing: 0.08em; text-transform: uppercase;
  color: var(--q-text-muted);
}
</style>
